<template>
  <LayoutBasic :showLinksMenu="false" width="300">
    <template v-slot:title>
      <v-list-item
        @click="$router.push({ name: `${baseRoute}.dashboard` })"
        class="hoverable py-2"
      >
        <v-list-item-icon class="mr-4">
          <v-icon color="grey lighten-1">mdi-chevron-left</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-h6 font-weight-black">Proveedores</v-list-item-title>
          <v-list-item-subtitle>Módulo de compras</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="grey darken-4"></v-divider>
    </template>

    <template v-slot:navigation-title> 
      <span class="grey--text text--lighten-1">Menú de Gestión</span> 
    </template>

    <template v-slot:navigation-content>
      <div class="pa-4">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar proveedor..."
          outlined rounded dense
          hide-details
          class="custom-search-field"
        ></v-text-field>
      </div>

      <v-list dense nav class="px-2">
        <v-subheader class="grey--text font-weight-black text-overline mb-2">Vistas</v-subheader>
        
        <v-list-item 
          :to="{ name: `${baseRoute}.proveedores` }" 
          exact
          class="rounded-lg mb-2"
          active-class="blue-gradient-active white--text"
        >
          <v-list-item-icon>
            <v-icon small>mdi-account-group-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Todos los proveedores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          :to="{ name: `${baseRoute}.proveedores.create` }" 
          class="rounded-lg mb-2"
          active-class="blue-gradient-active white--text"
        >
          <v-list-item-icon>
            <v-icon color="blue lighten-2" small>mdi-plus-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Registrar nuevo</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-4 grey darken-4"></v-divider>
        <v-subheader class="grey--text font-weight-black text-overline mb-2">Precios</v-subheader>

        <v-list-item 
          :to="{ name: `${baseRoute}.proveedores.listasdeprecio` }" 
          class="rounded-lg"
          active-class="blue-gradient-active white--text"
        >
          <v-list-item-icon>
            <v-icon small>mdi-tag-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Listas de precios</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  
    <template v-slot:vista-previa>
      <v-fade-transition mode="out-in">
        <router-view 
          :baseRoute="baseRoute" 
          :search="search"
        ></router-view>
      </v-fade-transition>
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";

export default {
  name: "ProveedoresIndex",
  components: { LayoutBasic },
  props: {
    baseRoute: { type: String, required: true }
  },
  data() {
    return {
      search: "",
    };
  },
};
</script>

<style scoped>
/* Estilo para el buscador */
.custom-search-field >>> .v-input__slot {
  background-color: #252526 !important;
  border: 1px solid #3e3e3e !important;
}

/* Gradiente para el ítem activo para que resalte con elegancia */
.blue-gradient-active {
  background: linear-gradient(90deg, rgba(33, 150, 243, 0.15) 0%, rgba(33, 150, 243, 0.05) 100%) !important;
  border-left: 3px solid #2196f3 !important;
}

.hoverable {
  cursor: pointer;
  transition: background 0.2s;
}

.hoverable:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.text-overline {
  font-size: 0.65rem !important;
  letter-spacing: 1.2px !important;
}
</style>